import { render, staticRenderFns } from "./AppConfigRulesList.vue?vue&type=template&id=1353c7b0"
import script from "./AppConfigRulesList.vue?vue&type=script&lang=js"
export * from "./AppConfigRulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports